import { createStyles, Theme } from '@material-ui/core/styles';
import { StyleRules } from '@material-ui/core/styles/withStyles';

const styles = (theme: Theme): StyleRules<string> => createStyles({
  root: {
    width: 'auto',
    backgroundColor: theme.palette.background.paper,
    zIndex: theme.zIndex.drawer + 1,
  },
  toolBar: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  sideBarButton: {
    color: theme.palette.text.primary,
  },
  userProfile: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
    '& .MuiTypography-root': {
      paddingLeft: theme.spacing(1),
    },
    '& .MuiButton-root': {
      minWidth: 0,
    },
  },
  logo: {
    height: 32,
  },
  titleContainer: {
    position: 'static',
    left: 'auto',
    right: 'auto',
    display: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '2px',
  },
  title: {
    lineHeight: 'initial',
    fontWeight: 400,
    fontSize: 'larger',
    position: 'absolute',
    left: theme.spacing(7),
    right: theme.spacing(7),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  subComponents: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    display: 'flex',
  },
});

export default styles;
